import { OptionalWithDefaultInjectionFacade as o } from "./optional-with-default-injection-facade.js";
import { ref as e } from "vue";
class t extends o {
  static KEY = Symbol("loading-state");
  constructor() {
    super(t.KEY, () => e(!1));
  }
}
export {
  t as LoadingStateInjectionFacade
};
//# sourceMappingURL=loading-state-injection-facade.js.map
